import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Help from "../views/Help";
import AboutUs from "../views/AboutUs";
import OurEvent from "../views/OurEvent";
import Subscribe from "../views/Subscribe";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: {
            title: 'Ludi Health : Le jeu au service de la santé',
            description: 'Le jeu au service de la santé',
            metaTags: [
                {
                    name: 'description',
                    content: 'Le jeu au service de la santé. '
                },
                {
                    property: 'og:description',
                    content: 'Le jeu au service de la santé. '
                },
                {
                    property: 'og:title',
                    content: 'Ludi Health : Le jeu au service de la santé'
                },
                {
                    property: 'og:url',
                    content: 'https://www.ludihealth.org'
                }
            ]
        }
    },
    {
        path: '/help',
        name: 'help',
        component: Help,
        meta: {
            title: 'Ludi Health : Le jeu au service de la santé',
            description: 'Le jeu au service de la santé',
            metaTags: [
                {
                    name: 'description',
                    content: 'Le jeu au service de la santé. '
                },
                {
                    property: 'og:description',
                    content: 'Le jeu au service de la santé. '
                },
                {
                    property: 'og:title',
                    content: 'Ludi Health : Le jeu au service de la santé'
                },
                {
                    property: 'og:url',
                    content: 'https://www.ludihealth.org/help'
                }
            ]
        }
    },
    {
        path: '/aboutus',
        name: 'aboutus',
        component: AboutUs,
        meta: {
            title: 'Ludi Health : Le jeu au service de la santé',
            description: 'Le jeu au service de la santé',
            metaTags: [
                {
                    name: 'description',
                    content: 'Le jeu au service de la santé. '
                },
                {
                    property: 'og:description',
                    content: 'Le jeu au service de la santé. '
                },
                {
                    property: 'og:title',
                    content: 'Ludi Health : Le jeu au service de la santé'
                },
                {
                    property: 'og:url',
                    content: 'https://www.ludihealth.org/aboutus'
                }
            ]
        }
    },
    {
        path: '/ourevent',
        name: 'ourevent',
        component: OurEvent,
        meta: {
            title: 'Ludi Health : Le jeu au service de la santé',
            description: 'Le jeu au service de la santé',
            metaTags: [
                {
                    name: 'description',
                    content: 'Le jeu au service de la santé. '
                },
                {
                    property: 'og:description',
                    content: 'Le jeu au service de la santé. '
                },
                {
                    property: 'og:title',
                    content: 'Ludi Health : Le jeu au service de la santé'
                },
                {
                    property: 'og:url',
                    content: 'https://www.ludihealth.org/ourevent'
                }
            ]
        }
    }, 
    {
        path: '/subscribe',
        name: 'subscribe',
        component: Subscribe,
        meta: {
            title: 'Ludi Health : Le jeu au service de la santé',
            description: 'Le jeu au service de la santé',
            metaTags: [
                {
                    name: 'description',
                    content: 'Vous inscrire pour participer à l\'événement.'
                },
                {
                    property: 'og:description',
                    content: 'Vous inscrire pour participer à l\'événement'
                },
                {
                    property: 'og:title',
                    content: 'Ludi Health : vous inscrire !'
                },
                {
                    property: 'og:url',
                    content: 'https://www.ludihealth.org/subscribe'
                }
            ]
        }
    },
    {path: "*", component: Home}
]

const router = new VueRouter({
    routes,
    mode: 'history'
})

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
    // This goes through the matched routes from last to first, finding the closest route with a title.
    // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

    // Find the nearest route element with meta tags.
    const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
    const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

    // If a route with a title was found, set the document (page) title to that value.
    if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

    // Remove any stale meta tags from the document using the key attribute we set below.
    Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

    // Skip rendering meta tags if there are none.
    if (!nearestWithMeta) return next();

    // Turn the meta tag definitions into actual elements in the head.
    nearestWithMeta.meta.metaTags.map(tagDef => {
        let tag
        if (tagDef.name !== undefined) {
            tag = document.querySelector('meta[name="' + tagDef.name + '"]')
        }
        if (tagDef.property !== undefined) {
            tag = document.querySelector('meta[property="' + tagDef.property + '"]')
        }
        if (tag) {
            tag.setAttribute("content", tagDef.content);
        } else {
            tag = document.createElement('meta');
        }

        Object.keys(tagDef).forEach(key => {
            tag.setAttribute(key, tagDef[key]);
        });

        // We use this to track which meta tags we create, so we don't interfere with other ones.
        tag.setAttribute('data-vue-router-controlled', '');

        return tag;
    })
        // Add the meta tags to the document head.
        .forEach(tag => document.head.appendChild(tag));

    next();
});

export default router
